import React, { useEffect } from "react";
import shape6 from "../../images/shape-6.png";
import shape24 from "../../images/shape-24.png";
import shape23 from "../../images/shape-23.png";
import shape5 from "../../images/shape-5.png";
import shape8 from "../../images/shape-8.png";
import author from "../../images/author-03.jpg";
import blog1 from "../../images/blog1.jpg";
import blog2 from "../../images/blog2in2.png";
import blog3 from "../../images/blog3.jpg";
import blog4 from "../../images/books.jpg";
import shape14 from "../../images/shape-14.png";
import shape12 from "../../images/shape-12.png";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import books from "../../images/books.jpg";

const Blog2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <Navbar/> */}

      <div class="section pageBanner">
        <div
          style={{
            backgroundColor: "rgba(0,0,0,0.4)",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            class="container"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div class="page-banner-content">
              {/* <ul class="breadcrumb">
                <li><a>Home</a></li>
                <li class="active">Blog</li>
            </ul> */}
              {/* <h2 class="title" style={{color:'#fff'}}> With numbers: What is the <br /> average salary and lifestyle of a physician in the USA? <span>January 10, 2023</span></h2> */}
            </div>
          </div>
        </div>
      </div>
      <div className="container ">
        <div className="row">
          <h2 class="title" style={{ color: "#000", paddingTop: "3%" }}>
            {" "}
            What is the USMLE?
          </h2>
        </div>
        <div className="row p-4">
          <div className="col-md-6">
            <img src={blog4} style={{ borderRadius: "10px" , width:'90%'}} alt="" />
          </div>
          <div className="col-md-6">
            <h5>
              <i
                class="fa-solid fa-check-double"
                style={{ color: "#ffc600" }}
              ></i>
           The United States Medical Licensing Examination (USMLE) is a multi-part professional exam that medical students and graduates must pass in order to practice medicine in the United States. The exam is sponsored by the Federation of State Medical Boards (FSMB) and the National Board of Medical Examiners (NBME).
            </h5>
            <h5>
              <i
                class="fa-solid fa-check-double"
                style={{ color: "#ffc600" }}
              ></i>
            The USMLE assesses a physician’s ability to apply knowledge, concepts, and principles, and to demonstrate fundamental patient-centered skills, that are important in health and disease and that constitute the basis of safe and effective patient care.
            </h5>
            <h5>
              <i
                class="fa-solid fa-check-double"
                style={{ color: "#ffc600" }}
              ></i>
            In summary, USMLE is a multi-part professional exam that medical students and graduates must pass in order to practice medicine in the United States. It assesses the examinee’s ability to apply knowledge, concepts, and principles, and to demonstrate fundamental patient-centered skills, that are important in health and disease and that constitute the basis of safe and effective patient care.
            </h5>
          </div>
        </div>
        <div className="row p-3">
          <div className="col-md-6">
            <h5>
              <i
                class="fa-solid fa-check-double"
                style={{ color: "#ffc600" }}
              ></i>
                 The USMLE is divided into three steps: <br />
            Step 1: Tests the medical knowledge of a student related to the basic sciences such as anatomy, pharmacology, and biochemistry. <br />

Step 2 Clinical Knowledge (CK): Tests the medical knowledge related to the clinical sciences such as internal medicine, pediatrics, and surgery. <br />

Step 3: Tests the medical knowledge and skills needed to practice medicine independently. <br />
            </h5>
          </div>
          <div className="col-md-6">
            
            <h5>
              <i
                class="fa-solid fa-check-double"
                style={{ color: "#ffc600" }}
              ></i>
                    It’s important to note that, the USMLE is not the only requirement for obtaining medical license, the medical graduates must also complete a residency program and pass any additional state-specific exams. Furthermore, the medical graduates must also meet any additional requirement of the state board where they wish to practice.

 
            </h5>
          </div>
        </div>
      </div>
      <div class="section section-padding">
            <div class="container">

                <div class="contact-wrapper">
                    <div class="row align-items-center">
                        <div class="col-lg-12">

                            <div class="contact-info">

                                <img class="shape animation-round" src={shape12} alt="Shape"/>
<h2>Leave A Reply</h2>
                           
                                <div class="single-contact-info">
                          
                                    <div class="info-content">
                                        <h6 class="title">Comment *</h6>
                                    
<textarea type="text" className='form-control' placeholder='Comment'/>
                                    </div>
                                </div>
                               
                           
                                <div class="single-contact-info">
                                   
                                    <div class="info-content">
                                        <h6 class="title">Name *</h6>
                                 
<input type="text" className='form-control' placeholder='Name' />
                                    </div>
                                </div>
                               
                           
                                <div class="single-contact-info">
                                  
                                    <div class="info-content">
                                        <h6 class="title">Email *</h6>
                                        <input type="text" className='form-control' placeholder='Email' />
                                    </div>
                                </div>
                               
                                <div class="single-contact-info">
                                  
                                  <div class="info-content">
                                      <h6 class="title">Website</h6>
                                      <input type="text" className='form-control' placeholder='Website' />
                                  </div>
                              </div>
                             <button class="btn btn-primary " style={{backgroundColor:'#FFC600', border:'#FFC600', borderRadius:'20px', float:'right'}}>Post Comment</button>
                            </div>
                           

                        </div>
                      
                    </div>
                </div>

            </div>
        </div>
        {/* <Footer/> */}
      </>
  );
};

export default Blog2;

